(ns renolit-roofing-service.view.project-view
  (:require [malli.util :as mu]
            [re-frame.core :as rf]
            [renolit-roofing-service.entity-list :as entity-list]
            [renolit-roofing-service.layout.components :refer [back-link-history entity-section]]
            [renolit-roofing-service.layout.display-item :as layout.display-item]
            [renolit-roofing-service.layout.grid-table :as layout.grid-table]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.layout.user-layout :as user-layout]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.service.project :as srv.project]
            [renolit-roofing-service.shared.util.string :refer [keyword->proper-case]]
            [renolit-roofing-service.user :as client.user]
            [renolit-roofing-service.util.react-date-range :as util.time]
            [renolit-roofing-service.util.localization :as util.localization]
            [renolit-roofing-service.view :as view]))

(def ^:const project-services-entity-key ::project-services)

(def path-params-schema
  [:map
   [:project-id
    [:uuid]]])

(def ^:const route-config
  {:name [:project]
   :auth-req? true
   :parameters {:path path-params-schema}
   :controllers [{:parameters {:path (mu/keys path-params-schema)}
                  :start #(rf/dispatch [::view.on-enter %])
                  :stop #(rf/dispatch [::view.on-leave %])}]})

(rf/reg-event-fx
 ::view.on-enter
 (fn [_ [_ opts]]
   (let [project-id (get-in opts [:path :project-id])]
     {:fx [[:dispatch [::srv.project/get-project-by-id project-id]]
           [:dispatch [::handle-list-option-updates opts]]]})))

(rf/reg-event-fx
 ::view.on-leave
 (fn [_ _]
   {:fx [[:dispatch [::srv.project/clear-project]]]}))

(rf/reg-event-fx
 ::handle-list-option-updates
 (fn [_ [_ {:keys [path]}]]
   (let [project-id (get path :project-id)]
     {:fx [[:dispatch [::load-list-data project-id]]]})))

(rf/reg-event-fx
 ::load-list-data
 (fn [_ [_ project-id {:keys [keep-prv-data?] :as _opts
                       :or {keep-prv-data? true}}]]
   {:fx [[:dispatch [::entity-list/load-list
                     {:entity-key project-services-entity-key
                      :uri "/api/services"
                      :keep-prv-data? keep-prv-data?
                      :extra-params {:filters {:project-id project-id}
                                     :related-entities {}}}]]]}))

(defn- basic-info-section
  [project]
  [:div.project-section.project-section--full
   [layout.display-item/main
    {:type :text
     :state project
     :path [:name]
     :label-transl-kw :domain.project/project-name}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:account-name]
     :label-transl-kw :domain.project/account-name}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-type]
     :label-transl-kw :domain.project/building-type}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-type-text]
     :label-transl-kw :domain.project/building-type-text}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:product]
     :label-transl-kw :domain.project/product}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:product-text]
     :label-transl-kw :domain.project/product-text}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:end-customer-name]
     :label-transl-kw :domain.project/end-customer-name}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:number]
     :label-transl-kw :domain.project/project-number}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:owner]
     :label-transl-kw :domain.project/owner}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:total-roof-area]
     :label-transl-kw :domain.project/total-roof-area}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:closing-date]
     :label-transl-kw :domain.project/closing-date}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:type]
     :label-transl-kw :domain.project/type}]])

(defn- building-address-info-section
  [project]
  [:div.project-section.project-section--half
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-country]
     :label-transl-kw :domain.project/building-country}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-region]
     :label-transl-kw :domain.project/building-region}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-state]
     :label-transl-kw :domain.project/building-state}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-city]
     :label-transl-kw :domain.project/building-city}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-zip]
     :label-transl-kw :domain.project/building-zip}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:building-street]
     :label-transl-kw :domain.project/building-street}]])

(defn- warranty-info-section
  [project]
  [:div.project-section.project-section--half
   [layout.display-item/main
    {:type :text
     :state project
     :path [:warranty-number]
     :label-transl-kw :domain.project/warranty-number}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:insured-period-years]
     :label-transl-kw :domain.project/insured-period-years}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:material-type]
     :label-transl-kw :domain.project/material-type}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:thickness]
     :label-transl-kw :domain.project/thickness}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:valid-until]
     :label-transl-kw :domain.project/valid-until}]])

(defn- meteo-indication-info-section
  [project]
  [:div.project-section.project-section--full
   [layout.display-item/main
    {:type :text
     :state project
     :path [:avg-anual-temp]
     :label-transl-kw :domain.project/avg-anual-temperature}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:max-temp]
     :label-transl-kw :domain.project/max-temperature}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:min-temp]
     :label-transl-kw :domain.project/min-temperature}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:accumulated-precipitation]
     :label-transl-kw :domain.project/accumulated-precipitation}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:hail-days]
     :label-transl-kw :domain.project/hail-days}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:avg-sunlight-hours]
     :label-transl-kw :domain.project/avg-sunlight-hours}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:solar-irradiation]
     :label-transl-kw :domain.project/solar-irradiation}]
   [layout.display-item/main
    {:type :text
     :state project
     :path [:avg-wind-speed]
     :label-transl-kw :domain.project/avg-wind-speed}]])

(defn- theoretic-degradation-curve
  [_project]
  [:div.project-section.project-section
   [layout.display-item/main
    {:type :text
     :value ""
     :multi-line true
     :label-transl-kw :page.project.details.theoretic-degradation-curve}]])

(defn- roof-life-cycle-section
  [project]
  [:div.project-section--inline
   [:div.project-section.project-section--half
    [layout.display-item/main
     {:type :text
      :state project
      :path [:building-type]
      :label-transl-kw :page.project.details.expected-product-life}]
    [layout.display-item/main
     {:type :text
      :state project
      :path [:building-type]
      :label-transl-kw :page.project.details.actual-product-life}]
    [layout.display-item/main
     {:type :text
      :state project
      :path [:building-type]
      :label-transl-kw :page.project.details.critical-window}]
    [layout.display-item/main
     {:type :text
      :state project
      :path [:building-type-text]
      :label-transl-kw :page.project.details.end-of-guarantee}]
    [layout.display-item/main
     {:type :text
      :state project
      :path [:product]
      :label-transl-kw :page.project.details.end-of-critical-window}]]
   [theoretic-degradation-curve project]])

(defn- service-details-link
  [service-id]
  (nav/href [:service-details] {:service-id service-id}))

(defn- service-list-section
  []
  (let [services (rf/subscribe [::entity-list/list project-services-entity-key])
        pagination (rf/subscribe [::entity-list/pagination project-services-entity-key])]
    (fn []
      [layout.grid-table/main
       {:data @services
        :pagination @pagination
        :grid-header-extra-class "grid-table__header--service-list"
        :grid-row-extra-class "grid-table__row--service-list"
        :cols [{:id :name
                :path [:name]
                :title-transl-kw :domain.service.name
                :cell-settings {:type :text}}
               {:id :reason
                :path [:reason]
                :title-transl-kw :domain.service.reason
                :cell-settings {:type :custom
                                :component (fn [reason]
                                             [:div.grid-table__cell
                                              [:span (util.localization/dropdown-value :service-reason reason)]])}}
               {:id :last-diagnosis-date
                :path [:last-diagnosis-date]
                :title-transl-kw :domain.service.last-diagnosis-date
                :cell-settings {:type :custom
                                :component (fn [last-diagnosis-date]
                                             (let [local-date (util.time/lib-date->date :local-date nil last-diagnosis-date)
                                                   formatted (util.time/format-date :local-date nil local-date)]
                                               [:div.grid-table__cell
                                                [:div.media-grid-item
                                                 [:span
                                                  formatted]]]))}}
               {:id :status
                :path [:status]
                :title-transl-kw :domain.service.state
                :cell-settings {:type :text
                                :format-content-fn keyword->proper-case}}
               {:id :inspector
                :path [:inspector]
                :title-transl-kw :domain.service.inspector
                :cell-settings {:type :text}}
               {:id :report

                :title-transl-kw :domain.service.report
                :cell-settings {:type :custom
                                :component (fn [{:keys [id status]}]
                                             [:div.grid-table__cell
                                              (when (= status "diagnosis-closed")
                                                [:a {:class "icon-link"
                                                     :href (service-details-link id)}
                                                 [layout.icon/icon
                                                  {:class ["arrow-link"]
                                                   :key :file}]])])}}
               {:id :nav-button
                :path [:id]
                :cell-settings {:type :custom
                                :component (fn [id]
                                             [:a {:class "icon-link"
                                                  :href (service-details-link id)}
                                              [layout.icon/icon
                                               {:class ["arrow-link"]
                                                :key :right-arrow}]])}}]}])))

(defn- main-body
  [project]
  [:<>
   [entity-section
    {:title-transl-kw :page.project.details.basic-project-data}
    [basic-info-section project]]
   [:div.project-section.project-section--half
    [entity-section
     {:title-transl-kw :page.project.details.building-address}
     [building-address-info-section project]]
    [entity-section
     {:title-transl-kw :page.project.details.warranty}
     [warranty-info-section project]]]
   [entity-section
    {:title-transl-kw :page.project.details.meteorological-indicators
     :button-component (fn []
                         [:button.btn.btn--quaternary
                          (t [:page.project.details/view-alerts])])}
    [meteo-indication-info-section project]]
   [entity-section
    {:title-transl-kw :page.project.details.roof-life-cycle-estimate}
    [roof-life-cycle-section project]]
   [entity-section
    {:title-transl-kw :page.project.details.diagnosis-made}
    [service-list-section]]])

(defn- main
  []
  (let [project-ref (rf/subscribe [::srv.project/project])
        project @project-ref
        user @(rf/subscribe [::client.user/user-data])]
    (when project
      [user-layout/main
       {:header-start [back-link-history (t [:common.go-back])]}
       [:div.project
        [:div.project_title-bar
         [:h1.user_layout_header_title (t [:common.project]) " "]
         (when (= (:role user) :rae)
           [:span.button [:a {:href (nav/href [:service-add] {:project-id (:id project)})}
                          (t [:page.project.details.start-diagnostic-service])]])]
        [main-body project-ref]]])))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
